import clsx, { ClassValue } from 'clsx'
import { DetailedHTMLProps, ReactNode } from 'react'

export type InputProps =
  Omit<DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'size'> & {
    label?: ReactNode
    size?: 'lg' | 'md' | 'sm' | 'xs'
    className?: ClassValue
    helperText?: ReactNode
    error?: boolean
  }

export function Input (props: InputProps) {
  const { label, size, className, helperText, error, ...inputProps } = props

  return (
    <label className="fieldset w-full">
      {label !== undefined && (
        <legend className="pb-1">
          <span
            className={clsx(
              'text-sm flex',
              error && 'text-error'
            )}
          >
            {label}
          </span>
        </legend>
      )}
      <input
        className={clsx(
          'input',
          'w-full',
          'text-sm',
          error && 'input-error',
          {
            'input-lg': size === 'lg',
            'input-md': size === 'md',
            'input-sm': size === 'sm',
            'input-xs': size === 'xs'
          },
          className
        )}
        {...inputProps}
      />
      {Boolean(helperText) && (
        <div className="label py-0">
          <span
            className={clsx(
              'min-h-5',
              error && 'text-error'
            )}
          >
            {helperText}
          </span>
        </div>
      )}
    </label>
  )
}
